(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection.filters.default"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-secondgear-brand-search]');
    if (!input) return;

    const filter = input.closest('.secondgear-brand-filter');
    if (!filter) return;

    const query = input.value.trim().toLocaleLowerCase();
    let visibleCount = 0;

    filter.querySelectorAll('[data-filter-label]').forEach((option) => {
      const label = (option.dataset.filterLabel || '').toLocaleLowerCase();
      const isVisible = query === '' || label.includes(query);
      option.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    const emptyMessage = filter.querySelector('[data-secondgear-brand-empty]');
    if (emptyMessage) emptyMessage.hidden = visibleCount !== 0;
  });
  } catch(e) { console.error(e); }
})();

})();
